module.exports = __webpack_public_path__ + "media/78.1cad7355.mp3";